export const socialConstants = {
    SOCIAL_LOGIN: 'SOCIAL_LOGIN',
    SOCIAL_LOGIN_PREPARE: 'SOCIAL_LOGIN_PREPARE',
    SOCIAL_LOGIN_REQUEST: 'SOCIAL_LOGIN_REQUEST',
    SOCIAL_LOGIN_SUCCESS: 'SOCIAL_LOGIN_SUCCESS',
    SOCIAL_LOGIN_FAILURE: 'SOCIAL_LOGIN_FAILURE',
    SOCIAL_LOGOUT: 'SOCIAL_LOGOUT',
};